import { jsx as s } from "react/jsx-runtime";
import t from "dayjs";
import { SaifaLogo as u, UnoXLogo as E, YxLogo as T, PreemLogo as N } from "../components/elements/station-logos/station-logos.js";
import { formatTimeWithOptionalMinutes as a } from "../../../helpers/date-helper.js";
const F = (r, e, n) => !r && !e ? n("CLOSED") : r === "00:00" && e === "" || r === "00:00" && e === "00:00" ? n("FIND_STATION_OPEN_24_HOURS") : `${a(r)}–${a(e)}`, _ = (r) => r.openingHours ? !!(r.openingHours.openingHourWeekday || r.openingHours.openingHourSaturday || r.openingHours.openingHourSunday) : !1, c = (r) => {
  if (!_(r))
    return null;
  switch (t().day()) {
    case 0:
      return { openingHour: r.openingHours.openingHourSunday, closeHour: r.openingHours.closeHourSunday };
    case 1:
    case 2:
    case 3:
    case 4:
    case 5:
      return { openingHour: r.openingHours.openingHourWeekday, closeHour: r.openingHours.closeHourWeekday };
    case 6:
      return {
        openingHour: r.openingHours.openingHourSaturday,
        closeHour: r.openingHours.closeHourSaturday
      };
    default:
      return null;
  }
}, I = (r) => (r.stationType === "02 Automat" || r.stationType === "03 TRUCK") && !_(r), D = (r, e) => {
  if (I(r))
    return e("FIND_STATION_OPENING_HOURS_UNMANNED");
  const o = c(r);
  return e("FIND_STATION_OPENING_HOURS_TODAY", {
    openingHours: o?.openingHour,
    closingHours: o?.closeHour
  });
}, p = (r) => {
  switch (r.stationType) {
    case "01 Bemannad":
      return !0;
    case "02 Automat":
      return !1;
    default:
      return !1;
  }
}, H = (r, e) => {
  switch (r) {
    case "01 Bemannad":
      return e("FIND_STATION_PREEM_MANNED");
    case "02 Automat":
      return e("FIND_STATION_PREEM_UNMANNED");
    case "03 TRUCK":
      return e("FIND_STATION_SAIFA_UNMANNED");
    default:
      return "Can't resolve stationType";
  }
}, f = (r, e) => {
  switch (r) {
    case "01 Bemannad":
    case "02 Automat":
      return e === "22 Uno X Truck" || e === "21 Uno X" ? /* @__PURE__ */ s(E, {}) : e === "20 Preem Truck YX" ? /* @__PURE__ */ s(T, {}) : /* @__PURE__ */ s(N, {});
    case "03 TRUCK":
      return /* @__PURE__ */ s(u, {});
    default:
      return null;
  }
}, L = (r, e) => {
  const n = [];
  if (r.fuelTypes)
    for (const o of r.fuelTypes)
      switch (o.name) {
        case "AdBlue": {
          n.push({
            id: "AdBlue",
            text: e("FIND_STATION_FUEL_AD_BLUE")
          });
          break;
        }
        case "ACPDiesel": {
          n.push({
            id: "ACPDiesel",
            text: e("FIND_STATION_FUEL_ACP_DIESEL")
          });
          break;
        }
        case "ACPDiesel50": {
          n.push({
            id: "ACPDiesel50",
            text: e("FIND_STATION_FUEL_ACP_DIESEL_50")
          });
          break;
        }
        case "Anlaggningsdiesel": {
          n.push({
            id: "Anlaggningsdiesel",
            text: e("FIND_STATION_FUEL_ANLAGGNINGSDIESEL")
          });
          break;
        }
        case "PreemEvolutionDiesel": {
          n.push({
            id: "PreemEvolutionDiesel",
            text: e("FIND_STATION_FUEL_PREEM_EVOLUTION_DIESEL")
          });
          break;
        }
        case "PreemEvolutionDieselFriFranRME": {
          n.push({
            id: "PreemEvolutionDieselFriFranRME",
            text: e("FIND_STATION_FUEL_PREEM_EVOLUTION_DIESEL_FRI_FRAN_RME")
          });
          break;
        }
        case "EvolutionBensin95": {
          n.push({
            id: "EvolutionBensin95",
            text: e("FIND_STATION_FUEL_EVOLUTION_BENSIN_95")
          });
          break;
        }
        case "Bensin95": {
          n.push({
            id: "Bensin95",
            text: e("FIND_STATION_FUEL_BENSIN_95")
          });
          break;
        }
        case "Bensin98": {
          n.push({
            id: "Bensin98",
            text: e("FIND_STATION_FUEL_BENSIN_98")
          });
          break;
        }
        case "EtanolE85": {
          n.push({
            id: "EtanolE85",
            text: e("FIND_STATION_FUEL_ETANOL_E85")
          });
          break;
        }
        case "PreemRedefineHVO100LattTrafikPersonbil":
        case "PreemRedefineHVO100LatttrafikPersonbil": {
          n.push({
            id: "PreemRedefineHVO100LattTrafikPersonbil",
            text: e("FIND_STATION_FUEL_PREEM_REDEFINE_HVO100_LIGHT_VEHICLE")
          });
          break;
        }
        case "PreemRedefineHVO100TungTrafik":
        case "PreemRedefineHVO100Tungtrafik": {
          n.push({
            id: "PreemRedefineHVO100TungTrafik",
            text: e("FIND_STATION_FUEL_PREEM_REDEFINE_HVO100_HEAVY_VEHICLE")
          });
          break;
        }
        case "HVO100LattTrafikPersonbil": {
          n.push({
            id: "HVO100LattTrafikPersonbil",
            text: e("FIND_STATION_FUEL_HVO100_LIGHT_VEHICLE")
          });
          break;
        }
        case "HVO100TungTrafik": {
          n.push({
            id: "HVO100TungTrafik",
            text: e("FIND_STATION_FUEL_HVO100_HEAVY_VEHICLE")
          });
          break;
        }
        case "LBGFlytandeBiogas": {
          n.push({
            id: "LBGFlytandeBiogas",
            text: e("FIND_STATION_FUEL_LBG_FLYTANDE_BIOGAS")
          });
          break;
        }
        case "Fordongas": {
          n.push({
            id: "Fordongas",
            text: e("FIND_STATION_FUEL_FORDONGAS")
          });
          break;
        }
      }
  return n;
}, A = (r, e) => {
  if (!r || !r.standard)
    return "";
  switch (r.standard.toLocaleLowerCase()) {
    case "ccs":
      return e("FIND_STATION_FUEL_EV_CONNECTOR_STANDARD_CCS");
    case "chademo":
      return e("FIND_STATION_FUEL_EV_CONNECTOR_STANDARD_CHADEMO");
    case "type2":
      return e("FIND_STATION_FUEL_EV_CONNECTOR_STANDARD_TYPE2");
    default:
      return "";
  }
}, g = (r, e) => {
  const n = [];
  for (const o of r.electricConnectors) {
    const i = A(o, e);
    n.push({
      id: o.power,
      text: e("FIND_STATION_FUEL_EV_CHARGING", { power: o.power, standard: i })
    });
  }
  return n;
}, R = (r, e) => {
  const n = [];
  return r.foodAndBeverages && n.push({
    id: "foodAndBeverages",
    text: e("FIND_STATION_SERVICE_FOOD_AND_BEVERAGES")
  }), r.trailerRental && n.push({
    id: "trailerRental",
    text: e("FIND_STATION_SERVICE_TRAILER_RENTAL")
  }), r.carWashAutomatic && n.push({
    id: "carWashAutomatic",
    text: e("FIND_STATION_SERVICE_CAR_WASH_AUTOMATIC")
  }), r.carWashSelfService && n.push({
    id: "carWashSelfService",
    text: e("FIND_STATION_SERVICE_CAR_WASH_SELF_SERVICE")
  }), r.espressoHouse && n.push({
    id: "espressoHouse",
    text: e("FIND_STATION_SERVICE_ESPRESSO_HOUSE")
  }), r.adaptedFor24mVehicles && n.push({
    id: "adaptedFor24mVehicles",
    text: e("FIND_STATION_SERVICE_ADAPTED_FOR_24M_VEHICLE")
  }), n;
};
export {
  _ as doesStationHaveOpeningHours,
  H as getLabelForStationType,
  f as getLogoForStation,
  F as getOpeningHoursStringFromTimePeriod,
  D as getTodaysOpeningHoursForStationType,
  p as isStationManned,
  I as isStationMissingOpeningHoursButOpenAroundTheClock,
  g as resolveElectricConnectorsForStation,
  L as resolveFuelsForStation,
  R as resolveServicesForStation
};
